<template>
  <v-flex xs12>
    <v-card>
      <v-list two-line subheader v-for="(reportGroup, i) in reportGroups" :key="i">
        <v-subheader>{{reportGroup.name}}</v-subheader>
        <report v-for="(item, i) in reportGroup.items" :key="i" :report="item"></report>
        <v-divider inset v-if="i != reportGroups.length - 1"></v-divider>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
import Report from "@/components/reports/report";
export default {
  components: {
    Report
  },
  data() {
    return {
      reportGroups: [
        {
          name: "Allocations & Dockets",
          items: [
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "Allocated, no docket received",
              subtitle: "",
              type: "allocations",
              id: 1
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title:
                "Allocated, docket received, no tipping docket (if required)",
              subtitle: "",
              type: "allocations",
              id: 2
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title:
                "Allocated, docket received, GPS inconsistent with allocation",
              subtitle: "",
              type: "allocations",
              id: 3
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "Allocated, docket received, GPS not available",
              subtitle: "",
              type: "allocations",
              id: 4
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title:
                "Allocated, docket received, docket has errors or omissions",
              subtitle: "",
              type: "allocations",
              id: 5
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "Allocated, docket received, tipping conflict",
              subtitle: "",
              type: "allocations",
              id: 6
            }
          ]
        },
        {
          name: "RCTIs",
          items: [
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "RCTI issued, no statutory declaration received",
              subtitle: "",
              type: "rctis",
              id: 7
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "RCTI discrepancy received",
              subtitle: "",
              type: "rctis",
              id: 8
            },
            {
              icon: "folder",
              iconColor: "grey lighten-1 white--text",
              title: "RCTI amendment approved",
              subtitle: "",
              type: "rctis",
              id: 9
            }
          ]
        }
      ],
      items: []
    };
  }
};
</script>

<style>
</style>
